import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import styled from '@emotion/styled'

import { uxEvent } from '../../../../flux/actions/ux'
import {
  EXPANDABLE_DRAWER_MODE_PREVIEW as PreviewMode,
  EXPANDABLE_DRAWER_MODE_EXPANDED as ExpandedMode,
} from '../../../../helpers/const'
import productHasValidVideo from '../../../../helpers/productHasValidVideo'

const StyledA = styled.a(() => ({
  textDecoration: 'none',
  cursor: 'pointer',
}))

const DrawerCard = ({
  productId,
  mediaType,
  children,
  onClick: onClickCallback,
}) => {
  const dispatch = useDispatch()
  const hasVideo = productHasValidVideo(mediaType)

  const onClick = e => {
    e.preventDefault()
    dispatch(uxEvent({
      name: 'toggle',
      target: 'ProductInfoDrawer/Open',
      params: {
        productId,
        mode: hasVideo ? ExpandedMode : PreviewMode,
      },
    }))
    onClickCallback()
  }

  return (
    <StyledA onClick={onClick} data-test="ProductDrawerCard">
      {children}
    </StyledA>
  )
}

DrawerCard.propTypes = {
  productId: PropTypes.string.isRequired,
  mediaType: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]).isRequired,
}

DrawerCard.defaultProps = {
  onClick: () => false,
}

DrawerCard.displayName = 'ProductDrawerCard'
DrawerCard.whyDidYouRender = true

export default DrawerCard
